import * as api from 'services/api';
import { addError } from 'actions/error';

export const getPostInfo = (id) => (dispatch) =>
  api.get(`articles/${id}`, 'GET_ARTICLES_INFO', dispatch).catch((error) => {
    dispatch(addError(new Error('GET_ARTICLES_INFO_ERROR')));
    return error;
  });

export const getArticlesCategories = () => (dispatch) =>
  api.get('article-categories', 'GET_ARTICLES_CATEGORIES_INFO', dispatch).catch((error) => {
    dispatch(addError(new Error('GET_ARTICLES_CATEGORIES_INFO_ERROR')));
    return error;
  });
